export default "__VITE_ASSET__DzkUvp7o__"